import $ from "jquery";
import Plyr from 'plyr';
import styles from 'plyr/dist/plyr.css';
 
$('.hero_e132').each(function(){
  var $element = $(this);
  var $video = $element.find('video');
  // var video_aspect_ratio = ($element.attr('data-video-aspect-ratio').length) ? $element.attr('data-video-aspect-ratio') : null;


  const player = new Plyr($video[0], {
    'controls': [],
    // 'ratio' : video_aspect_ratio,
    // 'autoplay': true,
    // 'muted': true,
    // 'volume': 0
  });
});